import React from 'react'
import Application from '../application'
import WizardNav from 'app/components/wizard_nav'
import DoorPreview from 'app/components/door_preview'
import Header from 'app/components/header'
import Footer from 'app/components/footer'
import constants from 'app/constants'
import { Spinner } from 'react-redux-spinner';
import { withRouter, Link } from 'react-router-dom'
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
import OrderCallPopup from 'app/components/order_call_popup'
import './style.scss'

class BasicLayout extends React.Component {
  constructor(props) {
    super(props);
  }

  renderOrderBackLink() {

    if (this.props.location.pathname == constants.ROUTES.ORDER && isBrowser) {
      return (
        <Link className='back-link' to={constants.ROUTES.STEP5}>Назад к доп. опциям</Link>
      );
    } else {
      return null;
    }
  }

  render() {
    return (
      <Application>
        <Spinner />
        <div className={`mobile-show ${ this.props.location.pathname == '/' ? 'hidden' : '' }`}>
          <DoorPreview />
        </div>
        <Header />
        <WizardNav />
        <section className={`page-content pge-${this.props.location.pathname.replace('/', '-')}`} id="js-page-content-top">
          <div className='base-width'>
            <div className='two-cols-layout clearfix'>
              <div className='col col-2 mobile-hidden'>
                <DoorPreview />
                {this.renderOrderBackLink()}
              </div>
              <div className='col col-1'>
                { this.props.children }
              </div>
            </div>
          </div>
        </section>
        <Footer />
        <OrderCallPopup />
      </Application>
    );
  }
}
export default withRouter(BasicLayout);




// WEBPACK FOOTER //
// ./app/javascript/app/layouts/basic_layout/index.jsx